<template>
  <v-app>
    <RouterView />
  </v-app>
</template>
